import React from 'react';
import './ProductPage.css';


const ProductPage = () => {
  return (
    <div className='product_css'>
        <>
      <div className="heading"> OUR POPULAR PRODUCTS </div>

    
      <div className="brand_name">
        ELECTRIC MOTORS
      </div>
   

<div className="box_conatainer">

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl1.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/m1.png" alt="" />
          </div>

          
        </div>
      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl3.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/m2.png" alt="" />
          </div>  
        </div>

      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl2.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/m3.png" alt="" />
          </div>  
        </div>
        
      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl4.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/m4.png" alt="" />
          </div>  
        </div>
        
      </div>  

</div>

{/* For the Transformer */}

<div className="brand_name">
        TRANSFORMER
      </div>
   

<div className="box_conatainer">

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl1.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/t1.png" alt="" />
          </div>

          
        </div>
      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl3.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/t2.png" alt="" />
          </div>  
        </div>

      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl5.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/t3.png" alt="" />
          </div>  
        </div>
        
      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl4.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/t4.png" alt="" />
          </div>  
        </div>
        
      </div>  

</div>

{/* For the Transformer */}

<div className="brand_name">
        VACCUM CIRCUIT BRAKER
      </div>
   

<div className="box_conatainer">

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl1.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/vcb1.png" alt="" />
          </div>

          
        </div>
      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl3.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/vcb2.png" alt="" />
          </div>  
        </div>

      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl4.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/vcb3.png" alt="" />
          </div>  
        </div>
        
      </div>

      <div className="product_box">
        <div className="product">
          <div className="topic"> <img src="images/cl2.jpg" alt="" /> </div>
          <div className="product_img">
              <img src="images/vcb4.png" alt="" />
          </div>  
        </div>
        
      </div>  

</div>
      
    </>
    </div>
  )
}

export default ProductPage
